"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../../pragma");

var _react = _interopRequireWildcard(require("react"));

var _ProgressItem = _interopRequireWildcard(require("./ProgressItem"));

var _ = require("../../..");

var styles = _interopRequireWildcard(require("./ProgressList.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ProgressList = props => {
  const {
    stories,
    activeStoryId,
    currentVideoDuration,
    isPaused,
    hasMediaError,
    onNext
  } = props;
  const [currentStoryProgress, setCurrentStoryProgress] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    setCurrentStoryProgress(0);
  }, [activeStoryId, stories]);
  const currentStoryDuration = (0, _react.useMemo)(() => {
    const storyDuration = stories[activeStoryId].duration || 5000;

    if (hasMediaError) {
      return 5000;
    }

    if (stories[activeStoryId].type === 'video') {
      return currentVideoDuration;
    }

    return storyDuration;
  }, [activeStoryId, currentVideoDuration, hasMediaError, stories]);
  const animationFrameId = (0, _react.useRef)();
  const incrementCount = (0, _react.useCallback)(() => {
    let progressCopy;
    setCurrentStoryProgress(prevCount => {
      progressCopy = prevCount + 100 / (currentStoryDuration / 1000 * 60);
      return progressCopy;
    });

    if (progressCopy && progressCopy < 100) {
      animationFrameId.current = window.requestAnimationFrame(incrementCount);
    } else {
      if (typeof animationFrameId.current === 'number') {
        window.cancelAnimationFrame(animationFrameId.current);
      }

      onNext();
    }
  }, [currentStoryDuration, onNext]);
  (0, _react.useEffect)(() => {
    const condition = !isPaused && currentStoryDuration > 0 && typeof activeStoryId !== 'undefined';

    if (condition) {
      animationFrameId.current = window.requestAnimationFrame(incrementCount);
    }

    return () => {
      if (typeof animationFrameId.current === 'number') {
        window.cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, [activeStoryId, currentStoryDuration, incrementCount, isPaused]);
  return (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "row",
    gap: 2,
    style: {
      width: '100%'
    }
  }, stories.map((story, i) => {
    let activationStatus;
    if (i === activeStoryId) activationStatus = 'inProgress';else if (i < activeStoryId) activationStatus = 'filled';else activationStatus = 'empty';
    const generatedStoryId = "".concat(i, " ").concat(story.url);
    return (0, _pragma.createFelaElement)(_ProgressItem.default, {
      key: generatedStoryId,
      activationStatus: activationStatus,
      progressStatus: currentStoryProgress,
      css: styles.progressItemStyle,
      cssProps: {
        width: "".concat(1 / stories.length * 100, "%")
      }
    });
  }));
};

var _default = ProgressList;
exports.default = _default;
//# sourceMappingURL=ProgressList.js.map